import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import ErrorBoundary from '../Common/ErrorBoundary';

const DashboardLayout = () => {
  return (
    /* This is the Flex Row (Sidebar | Content) */
    <div className="dashboard-layout">
      
      <Sidebar /> 
      
      {/* This is the Flex Column (Header | Main) */}
      <div className="dashboard-content">
        <Header /> 
        
        <main className="main-content">
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
      
    </div>
  );
};

export default DashboardLayout;